"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shallowCompare = void 0;

var _commonConstants = require("./common-constants");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var shallowCompare = function shallowCompare(object1, object2) {
  if (_typeof(object1) === _commonConstants.OBJECT_TYPE && _typeof(object2) === _commonConstants.OBJECT_TYPE) {
    var allObjKeys = Object.keys(object1);

    for (var _i = 0, _allObjKeys = allObjKeys; _i < _allObjKeys.length; _i++) {
      var key = _allObjKeys[_i];

      if (object1[key] !== object2[key]) {
        return false;
      }
    }

    return true;
  } else {
    return object2 === object1;
  }
};

exports.shallowCompare = shallowCompare;